import { combineReducers } from "redux";
import advanceSalaryReducer, {
  AdvanceSalaryState,
} from "./advanceSalaryReducer";
import AttendanceReducer, { AttendanceState } from "./attendanceReducer";
import contractorReducer, { ContractorState } from "./contractorReducer";
import employeeReducer, { EmployeeState } from "./employeeReducer";
import employerReducer, { EmployerState } from "./employerReducer";
import leaveReducer, { LeaveState } from "./leaveReducer";
import LoginStateReducer, { LoginState } from "./login";
import PayrollReducer, { PayrollState } from "./payrollReducer";
import reportsReducer, { ReportsState } from "./reportsReducer";
import UIStateReducer, { UIState } from "./ui";
import vendorReducer, { VendorState } from "./vendorReducer";

export interface ReduxState {
  ui: UIState;
  login: LoginState;
  payroll: PayrollState;
  employee: EmployeeState;
  attendance: AttendanceState;
  leave: LeaveState;
  vendor: VendorState;
  employer: EmployerState;
  contractor: ContractorState;
  reports: ReportsState;
  advanceSalary: AdvanceSalaryState;
}

export default combineReducers<ReduxState>({
  ui: UIStateReducer,
  login: LoginStateReducer,
  payroll: PayrollReducer,
  attendance: AttendanceReducer,
  employee: employeeReducer,
  leave: leaveReducer,
  vendor: vendorReducer,
  employer: employerReducer,
  contractor: contractorReducer,
  reports: reportsReducer,
  advanceSalary: advanceSalaryReducer,
});
